var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8916 0H22.5542L14.5542 9.20482L24 21.6867H16.5783L10.7952 14.1205L4.14458 21.6867H0.481928L9.06024 11.8554L0 0H7.61446L12.8675 6.93976L18.8916 0ZM17.5904 19.4699H19.6145L6.50602 2.07229H4.28916L17.5904 19.4699Z",
    fill: "#DBE8FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.6867,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.ab083b26e976f06e0cd9cecddf10478a.svg";
export { ForwardRef as ReactComponent };